import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { theme, t } from '../theme';
import { EMPRESA } from './consentContent';

/**
 * Solicitação de exclusão de conta SEM login.
 *
 * POR QUE EXISTE: a Google Play exige um caminho de exclusão acessível sem
 * instalar o aplicativo. Quem desinstalou, perdeu o acesso ou nunca teve o
 * aparelho também tem esse direito — e o caminho de dentro do app não atende.
 *
 * O formulário apenas REGISTRA o pedido. A exclusão continua passando por
 * verificação humana dentro do prazo da LGPD: apagar dados de confeitaria
 * inteira a partir de um formulário anônimo seria um vetor de sabotagem.
 */
export default function ExcluirContaPublica() {
  const [email, setEmail] = useState('');
  const [motivo, setMotivo] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [erro, setErro] = useState(null);

  const enviar = async (e) => {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await api.post('/public/deletion-request', { email: email.trim(), motivo });
      setEnviado(true);
    } catch (err) {
      // 429 é o único caso em que vale explicar: o resto responde 200 de
      // propósito, para o endpoint não virar verificador de quem tem conta.
      setErro(err?.response?.status === 429
        ? 'Muitas solicitações deste dispositivo. Tente novamente em uma hora.'
        : 'Não consegui registrar agora. Tente de novo em instantes ou escreva para ' + EMPRESA.email + '.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="pagina-publica" style={{ minHeight: '100vh', background: theme.colors.bg, paddingLeft: 16, paddingRight: 16 }}>
      <div style={{ maxWidth: 520, margin: '0 auto' }}>
        <Link to="/" style={{ display: 'inline-block', marginBottom: 24 }}>
          <img src="/metria-logo.svg" alt="Metria" style={{ height: 28 }} />
        </Link>

        <div style={{
          background: theme.colors.bgCard, borderRadius: 16, padding: '28px 24px',
          border: `1px solid ${theme.colors.border}`,
        }}>
          {/* O nome do app precisa aparecer como TEXTO: a Play exige que a pagina
              mencione o app ou a desenvolvedora que constam na ficha da loja, e
              logo com alt nao conta para quem esta conferindo a exigencia. */}
          <h1 style={{ fontSize: 20, fontWeight: 700, color: theme.colors.text, margin: '0 0 8px' }}>
            Excluir minha conta do Metria
          </h1>
          <p style={{ fontSize: 13, color: theme.colors.textSecondary, margin: '0 0 16px' }}>
            Metria, de {EMPRESA.nome}
          </p>

          {enviado ? (
            <div>
              <p style={{ fontSize: 14, lineHeight: 1.7, color: theme.colors.text }}>
                Recebemos sua solicitação. Se houver uma conta com este e-mail, os dados
                serão excluídos em até <strong>15 dias</strong>, conforme a LGPD, e você
                receberá uma confirmação por e-mail.
              </p>
              <p style={{ fontSize: 13, color: theme.colors.textSecondary, lineHeight: 1.6 }}>
                Se você tem uma assinatura contratada pela App Store ou pela Google Play,
                <strong> cancele também na loja</strong> — a exclusão da conta aqui não
                interrompe a cobrança feita por elas.
              </p>
            </div>
          ) : (
            <form onSubmit={enviar}>
              <p style={{ fontSize: 14, lineHeight: 1.7, color: theme.colors.textSecondary, marginTop: 0 }}>
                Para solicitar a exclusão da sua conta e dos seus dados:
              </p>
              <ol style={{
                fontSize: 14, lineHeight: 1.8, color: theme.colors.textSecondary,
                margin: '0 0 16px', paddingLeft: 20,
              }}>
                <li>Informe abaixo o e-mail cadastrado na conta.</li>
                <li>Se quiser, conte o motivo — é opcional.</li>
                <li>Toque em <strong>Solicitar exclusão</strong>.</li>
                <li>Você recebe a confirmação por e-mail em até 15 dias, prazo da LGPD.</li>
              </ol>

              <div style={{ background: theme.colors.bgSection, borderRadius: 10, padding: 12, marginBottom: 16 }}>
                <p style={{ fontSize: 13, color: theme.colors.textSecondary, margin: 0, lineHeight: 1.6 }}>
                  <strong>O que é excluído:</strong> cadastro, ingredientes, fichas técnicas,
                  clientes, pedidos, estoque e fotos anexadas.<br />
                  <strong>O que é mantido:</strong> registros fiscais de pagamentos já
                  realizados, guardados por 5 anos, prazo exigido pela legislação
                  tributária brasileira. Depois disso eles também são apagados.
                </p>
              </div>

              {erro && <div style={t.error}>{erro}</div>}

              <label style={t.label}>E-mail da conta</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                style={{ ...t.input, marginBottom: 12 }}
              />

              <label style={t.label}>Motivo (opcional)</label>
              <textarea
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
                rows={3}
                placeholder="Nos ajuda a melhorar"
                style={{ ...t.input, marginBottom: 16, resize: 'vertical' }}
              />

              <button
                type="submit"
                disabled={enviando}
                style={{ ...t.btnPrimary, width: '100%', padding: 14, opacity: enviando ? 0.6 : 1 }}
              >
                {enviando ? 'Enviando…' : 'Solicitar exclusão'}
              </button>
            </form>
          )}

          <hr style={{ border: 0, borderTop: `1px solid ${theme.colors.borderLight}`, margin: '20px 0 14px' }} />
          <p style={{ fontSize: 12, color: theme.colors.textSecondary, lineHeight: 1.6, margin: 0 }}>
            Se preferir, escreva para <strong>{EMPRESA.email}</strong>.<br />
            {EMPRESA.nome} · CNPJ {EMPRESA.cnpj}
          </p>
          <div style={{ display: 'flex', gap: 16, marginTop: 14, fontSize: 13 }}>
            <Link to="/privacidade">Política de Privacidade</Link>
            <Link to="/termos">Termos de Uso</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
